'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const scaleCorrection = require('../../render/dom/projection/scale-correction.js');
const transform = require('../../render/html/utils/transform.js');

function isForcedMotionValue(key, _a) {
  var layout = _a.layout,
    layoutId = _a.layoutId;
  return transform.isTransformProp(key) || transform.isTransformOriginProp(key) || (layout || layoutId !== undefined) && !!scaleCorrection.valueScaleCorrection[key];
}

exports.isForcedMotionValue = isForcedMotionValue;
